/*
* 工单信息组件
* zxw
* 创建时间：
* 修改时间：2026-07-08
*/

import { useState, useEffect } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    Flex,
    Modal,
    Button,
    Checkbox,
    Tag,
    Image,
    ConfigProvider,
    message,
    theme,
    Statistic,
} from 'antd';
import {
    locale,
    Html2pdf,
    UjoinParams,
    AddRequestHeaders,
    defaultImage,
    AliyunOSSclient,
    BrandUrl,
    SloganUrl,
} from '../../incs/FunHelper.js';

/***
 * 打印工单
 */
const WOInfo = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [woImageList, setWOImageList] = useState([]);

    const {
        token: {
            colorPrimary,
            colorPrimaryBg,
            colorSuccess,
            colorSuccessBg,
            fontSize,
        },
    } = theme.useToken();

    const cancel = () => { props.setOpen(false); setWOImageList([]); }
    const printer = () => {
        var printContents = document.getElementById('print-info-id').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    }
    const download = () => {
        // 获取到产品实体信息才可以下载
        setLoading(true);
        new Promise(function (resolve, reject) {
            try {
                Html2pdf('print-info-id', props.record.number, '', woImageList.length > 0 ? true : false);
                resolve();
            } catch {
                reject();
            }
        }).then(() => {
            cancel();
        }, () => {
            messageApi.success('下载失败！', CNF.messageDuration);
            setLoading(false);
        });
    };

    /**
     * 获取工单图片列表
     */
    const getWOImageLists = (woUlid) => {

        const params = {
            rss: 'list',
            wo_ulid: woUlid,
            start_date: '',
            end_date: '',
            page_size: CNF.pageSize,
            current_index: 1
        };

        $.ajax({
            url: `${CNF.api}wos/images${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        let woImageList = [];
                        let imageArr = data.dat;
                        let params = { acl: 'GetObject' }
                        $.ajax({
                            url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
                            headers: AddRequestHeaders(),
                            type: 'GET', success: function (data) {
                                if (data.res === 0) {
                                    const token = data.dat;
                                    for (let i = 0; i < imageArr.length; i++) {
                                        let item = imageArr[i];
                                        try {
                                            //  去掉路径‘/’
                                            let result = AliyunOSSclient(token).signatureUrl(item.path, {
                                                expires: 3600,
                                                response: {
                                                    'content-disposition': 'attachment; filename="' + item.name + '"'
                                                }
                                            });
                                            woImageList.push({
                                                uid: i + 1,
                                                ulid: item.key,
                                                url: result,
                                                preview: result,
                                                status: 'done',
                                                percent: 100,
                                                size: item.size,
                                                path: item.path,
                                                description: item.description
                                            });
                                        } catch (e) {
                                            console.log(e);
                                        }
                                    }
                                    setWOImageList(woImageList);
                                } else {
                                    message.error(data.msg, CNF.messageDuration);
                                }
                            }
                        });
                    } else {
                        setWOImageList([]);
                    }
                }
            }
        })
    }

    useEffect(() => {
        if (props.btnLists.indexOf('btn_plms_wo_image') >= 0) {
            getWOImageLists(props.record.key);
        }
    }, [props]);

    return (
        <>
            {contextHolder}
            <Modal
                style={{ top: 0 }}
                closable={true}
                open={props.open}
                keyboard={true}
                width={820}
                onCancel={cancel}
                footer={[
                    <Button key='back' onClick={cancel} disabled={loading}>取消</Button>,
                    <Button key='submit' type='primary' onClick={printer} disabled={loading}>打印</Button>,
                    <Button key='link' type='primary' onClick={download} disabled={loading} style={{ marginRight: '24px' }}>下载</Button>,
                ]}
            >
                <div id='print-info-id'>
                    <div className='print-info' style={{ padding: '0 30px' }}>
                        <div id='table-id'>
                            <Flex justify='space-between' style={{ marginBottom: '10px' }}>
                                <img src={BrandUrl} height='35px' alt={props.preGroup || CNF.companyShortName} />
                                <img src={SloganUrl} height='35px' alt={props.preGroup || CNF.companyShortName} />
                            </Flex>
                            <table width='100%'>
                                <thead align='center'>
                                    <tr>
                                        <th colSpan='24' ><h2>工单报告</h2></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colSpan='4' style={{ width: 120 }}>工单编号: </td><td colSpan='8' style={{ width: 240 }}>{props.record.number}</td>
                                        <td colSpan='4' style={{ width: 120 }}>产品编号: </td><td colSpan='8' style={{ width: 240 }}>{props.record.product_number}</td>
                                    </tr>
                                    <tr><td colSpan='4' style={{ width: 120 }}>所属项目: </td><td colSpan='20' style={{ width: 600 }}>{props.record.project_name}</td></tr>
                                    <tr>
                                        <td colSpan='4' style={{ width: 120 }}>工单类型: </td><td colSpan='8' style={{ width: 240 }}>{props.record.type}</td>
                                        <td colSpan='4' style={{ width: 120 }}>工单等级: </td><td colSpan='8' style={{ width: 240 }}>{
                                            CNF.woLevels.map((item) => {
                                                if (parseInt(props.record.level) === parseInt(item.value)) {
                                                    return <span key={item.value}>{item.key}</span>;
                                                } else {
                                                    return '';
                                                }
                                            })
                                        }</td>
                                    </tr>
                                    <tr>
                                        <td colSpan='4' style={{ width: 120 }}>开始时间: </td><td colSpan='8' style={{ width: 240 }}>{props.record.start_time}</td>
                                        <td colSpan='4' style={{ width: 120 }}>结束时间: </td><td colSpan='8' style={{ width: 240 }}>{props.record.end_time}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan='4' style={{ width: 120 }}>回访客户: </td><td colSpan='8' style={{ width: 240 }}>{props.record.visit_status}</td>
                                        <td colSpan='4' style={{ width: 120 }}>维护费用: </td><td colSpan='8' style={{ width: 240 }}><Tag color={colorPrimaryBg}><Statistic precision={CNF.DPL} suffix={props.record && props.record.out_fee > 10000 ? '万元' : '元'} styles={{ content: { fontSize: fontSize - 2, color: colorPrimary } }} value={props.qss && props.record.out_fee > 10000 ? props.record.amount / 10000 : props.record.out_fee} /></Tag></td>
                                    </tr>
                                    <tr>
                                        <td colSpan='4' style={{ width: 120 }}>工单状态: </td><td colSpan='8' style={{ width: 240 }}>{<Tag color={props.record.status === CNF.status[0].value ? colorSuccessBg : colorPrimaryBg} style={{ color: props.record.status === CNF.status[0].value ? colorSuccess : global.THEMECOLOR }}>{props.record.status}</Tag>}</td>
                                        <td colSpan='4' style={{ width: 120 }}>处理人员: </td><td colSpan='8' style={{ width: 240 }}>{props.record.do_user}</td>
                                    </tr>
                                    <tr><td colSpan='4' style={{ width: 120 }}>工单描述: </td><td colSpan='20' style={{ width: 600 }}>{
                                        props.record.content && props.record.content.split('\n').map((item, index) => {
                                            return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                        })}
                                    </td></tr>
                                    <tr><td colSpan='4' style={{ width: 120 }}>工单点位: </td><td colSpan='20' style={{ width: 600 }}>{props.record.point}</td></tr>
                                    <tr><td colSpan='4' style={{ width: 120 }}>原因描述: </td><td colSpan='20' style={{ width: 600 }}>{
                                        props.record.cause && props.record.cause.split('\n').map((item, index) => {
                                            return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                        })}
                                    </td></tr>
                                    <tr><td colSpan='4' style={{ width: 120 }}>处理方式: </td><td colSpan='20' style={{ width: 600 }}>{
                                        props.record.do_mode && props.record.do_mode.split('\n').map((item, index) => {
                                            return <p key={index} style={{ margin: 0 }}>{item}</p>;
                                        })}
                                    </td></tr>
                                    <tr><td colSpan='4' style={{ width: 120 }}>客户评价: </td><td colSpan='20' style={{ width: 600 }}><Checkbox>满意</Checkbox><Checkbox>不满意</Checkbox></td></tr>
                                    <tr><td height='80px'>客户签字<br />（盖章）</td><td colSpan='20' style={{ width: 600 }} height='80px'></td></tr>
                                </tbody>
                            </table>
                        </div>
                        {
                            props.btnLists.indexOf('btn_plms_wo_image') >= 0 && woImageList.length > 0 ? <>
                                <div>
                                    {
                                        woImageList.length > 0 ? <p>附图: </p> : ''
                                    }
                                    <ConfigProvider locale={locale}>
                                        {
                                            woImageList.map((item, index) => {
                                                return <Image
                                                    className='whole-node'
                                                    key={index}
                                                    alt={item.name}
                                                    width='50%'
                                                    src={item.url}
                                                    style={{ verticalAlign: 'top', maxWidth: '100%', height: 'auto' }}
                                                    fallback={defaultImage}
                                                />
                                            })
                                        }
                                    </ConfigProvider>
                                </div>
                            </> : ''
                        }
                    </div>
                </div>
            </Modal>
        </>
    );
}

export default WOInfo;